export default __webpack_public_path__ + "../staticImages/cyber_wine-260.png";